/**
 * How many leading tabs fit on one line once the rest collapse into More.
 * `available` is the strip's width. A non-positive width means it has not
 * been measured yet, so every tab stays out rather than flashing an empty
 * strip. The gap before More is reserved whenever anything overflows.
 */
export const fitTabCount = ({
  widths,
  available,
  moreWidth,
  gap,
}: {
  widths: number[];
  available: number;
  moreWidth: number;
  gap: number;
}) => {
  const count = widths.length;
  if (count === 0 || available <= 0) return count;
  const total =
    widths.reduce((sum, width) => sum + width, 0) + gap * (count - 1);
  if (total <= available) return count;

  const budget = available - moreWidth - gap;
  let used = 0;
  let visible = 0;
  for (const width of widths) {
    const next = used + (visible > 0 ? gap : 0) + width;
    if (next > budget) break;
    used = next;
    visible += 1;
  }
  return visible;
};
